import { apiClient } from './client';

interface PaginatedResponse<T> {
  items: T[];
  total: number;
  page: number;
  pageSize: number;
  totalPages: number;
}

export const adminApi = {
  getLogsStats: async (): Promise<{
    total: number;
    today: number;
    week: number;
    uniqueUsersToday: number;
    actionsByType: Array<{ action: string; count: number }>;
    loginToday: { success: number; failed: number };
  }> => {
    const response = await apiClient.get<{ success: boolean; data: any }>('/admin/logs/stats');
    return response.data;
  },

  getLogs: async (params: {
    page?: number;
    pageSize?: number;
    userId?: string;
    username?: string;
    action?: string;
  } = {}): Promise<PaginatedResponse<{
    id: string;
    user_id: string | null;
    action: string;
    data: string;
    ip_address: string | null;
    user_agent: string | null;
    created_at: number;
    username: string | null;
  }>> => {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.set('page', params.page.toString());
    if (params.pageSize) queryParams.set('pageSize', params.pageSize.toString());
    if (params.userId) queryParams.set('userId', params.userId);
    if (params.username) queryParams.set('username', params.username);
    if (params.action) queryParams.set('action', params.action);

    const response = await apiClient.get<{
      success: boolean;
      data: {
        logs: Array<{
          id: string;
          user_id: string | null;
          action: string;
          data: string;
          ip_address: string | null;
          user_agent: string | null;
          created_at: number;
          username: string | null;
        }>;
        total: number;
        page: number;
        pageSize: number;
        totalPages: number;
      };
    }>(`/admin/logs?${queryParams.toString()}`);

    return {
      items: response.data.logs,
      total: response.data.total,
      page: response.data.page,
      pageSize: response.data.pageSize,
      totalPages: response.data.totalPages,
    };
  },

  cleanup: async (): Promise<{
    oldActions: number;
  }> => {
    const response = await apiClient.post<{
      success: boolean;
      data: { oldActions: number };
    }>('/admin/cleanup', {});
    return response.data;
  },
};
